<script>
export default
{
    name: 'text-slot',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='text-slot'>
                { this.$slots.default }
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.text-slot
{
    font-size: 2.2vh;
    line-height: 1.5;

    .OnDesktop({ font-size: 1.2vw; });
    .OnLarge({ font-size: 1vw; });

    b
    {
        color: var(--theme-accent-color);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/TextSlot.vue